import React, { Component } from 'react';
import lookups from '../lookups.json'; //lookup tables for all the possible choices
import './Dialogs.min.css';

class SaveDialog extends Component {
    constructor(props) {
        super(props);
    }
    sendEmail() {

      //save SF data
        var url_sf = this.props.urlDW2 + "/Integration?run=MTS_244_Sales&Transition=Save";

        var customer = [];
        customer.push("CustFirstName=" + this.props.customer.firstName);
        customer.push("CustLastName=" + this.props.customer.lastName);
        customer.push("CustEmail=" + this.props.customer.email);
        customer.push("CustCompany=" + this.props.customer.company);
        customer.push("CustPhone=" + this.props.customer.phone);
        customer.push("CustCountry=" + this.props.customer.country);
        customer.push("CustProject=" + this.props.customer.projectName);
        url_sf+= "&" + customer.join("&");

        
        for(var i = 0; i < this.props.data.parameters.length; i++){
            url_sf+= "&" + this.props.data.parameters[i].dwVar + "=" + (parseInt(this.props.data.parameters[i].choice + 1)); 
        }
                   
        var iframe = document.querySelector("#test_iframe");
        iframe.src = url_sf; //send current setup to second iframe tied to another instance of the DW stuff
        console.log("sent = " + url_sf);

        //create saved url
        var url = this.props.urlSite + '/244configurator/';
        url += "?a=" + this.props.data.id;
        for (var i = 0; i < this.props.data.parameters.length; i++) {
            url += "&" + this.props.data.parameters[i].saveVar + "=" + this.props.data.parameters[i].choice;
        }

        var html = "";
        var date = new Date();

        //create email content
        html += "<div>Thank you for using the MTS 3D Studio product configurator.  You can retrieve or edit your design by clicking the button below. If you have any questions please call (800) 328-2255.</div>";
        html += "<br />";
        html += "<div><span style='font-weight:bold'>Date:</span> " + (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(-2) + "</div>";
        html += "<br />";
        html += "<div><span style='font-weight:bold'>Product:</span> Actuator</div>";
        html += "<br />";
        html += "<div><span style='font-weight:bold'>Project:</span> " + this.props.customer.projectName + "</div>";
        html += "<br />";
        html += "<div style='margin-bottom: .5em; font-weight: bold'>Configured Options:</div>";

        html += "<table class='configTable'>";
        html += "<thead><tr><th>Option</th><th>Selection</th></tr></thead>";
        html += "<tbody>";
        html += "<tr><td>Actuator</td><td>" + this.props.at + "</td></tr>";

        //create table of the current configuration
        for (var i = 0; i < this.props.data.parameters.length; i++) {
            var choices = [];
            var choice = this.props.data.parameters[i].choice;
            var arrChoices = this.props.data.parameters[i].choices.split(",");
            if (arrChoices[0] == "all") {
                choices = this.props.lookups.options[i].choices;
            } else {
                for (var j = 0; j < arrChoices.length; j++) {
                    choices.push(this.props.lookups.options[i].choices[arrChoices[j]]);
                }
            }
            html += "<tr><td>" + this.props.data.parameters[i].title + "</td><td>" + choices[choice].title + "</td></tr>";
        }
        html += "</tbody></table>";

        //retrieve design button
        html += '<div style="margin-top: 3em; display: block;"> ';
        html += '<!--[if mso]>';
        html += '<v:rect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="' + url + '" style="height:40px;v-text-anchor:middle;width:200px;" stroke="f" fillcolor="#b01921">';
        html += '<w:anchorlock/>';
        html += '<center>';
        html += '<![endif]-->';
        html += '<a href="' + url + '" style="background-color:#b01921;color:#ffffff;display:inline-block;font-family:sans-serif;font-size:13px;font-weight:bold;line-height:40px;text-align:center;text-decoration:none;width:200px;-webkit-text-size-adjust:none;">Retrieve Your Design</a>';
        html += '<!--[if mso]>';
        html += '</center>';
        html += '</v:rect>';
        html += '<![endif]-->';
        html += '</div>';

        //html += "<a style='color: #FFF; font-weight: bold; text-decoration: none;' href='" + url + "'><div style='background-color: #ae1c26; padding: 10px; text-align: center;'>Retrieve Your Design</div></a>";


        //call email webservice
        const options = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                mailfrom: "MTS 3D Studio <design_studio@mts.com>",
                mailto: this.props.customer.email,
                subject: "Your MTS 3D Design Studio Configuration is Saved",
                header: "MTS 3D Studio Product Configuration",
                subtitle: "Your MTS 3D Design Studio Configuration is Saved",
                html: html
            })
        };

        fetch(this.props.urlSite + '/nodemailer/server.js', options).catch(err => {
            console.error('Request failed', err)
        });

        this.props.onClick(null)
    }
    render() {
        return (
            <div id="dlg_save" className="dialog">
                <div className="dlg_modal save">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Save Your Design</div>
                        <div className="dlg_exit" onClick={() => this.sendEmail()}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <span className="dlg_sub_head">Your design has been saved</span>
                            <span className="dlg_body">After clicking 'Submit' below, you will receive an email containing a summary of your configuration and a link that will allow you to retrieve your design.</span>
                        </div>
                        <div id="dlg_export_btn_2" className="dlg_btn" onClick={() => this.sendEmail()}>SUBMIT</div>
                    </div>
                </div>
            </div>
        )

    }
}
export default SaveDialog;